import { render, staticRenderFns } from "./TeamAudiList.vue?vue&type=template&id=a115b626&scoped=true"
import script from "./TeamAudiList.vue?vue&type=script&lang=js"
export * from "./TeamAudiList.vue?vue&type=script&lang=js"
import style0 from "./TeamAudiList.vue?vue&type=style&index=0&id=a115b626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a115b626",
  null
  
)

export default component.exports